import { render, staticRenderFns } from "./richEditor.vue?vue&type=template&id=db233c5e&"
import script from "./richEditor.vue?vue&type=script&lang=js&"
export * from "./richEditor.vue?vue&type=script&lang=js&"
import style0 from "./richEditor.vue?vue&type=style&index=0&id=db233c5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports